/**
 * Appointment Module Entry Point
 * Orchestrates appointment calendar and form functionality
 */

import AppointmentCalendar from './calendar.js';
import AppointmentForm from './form.js';

export default class AppointmentModule {
    constructor() {
        this.calendar = null;
        this.form = null;

        this.init();
    }

    /**
     * Initialize appointment module components
     */
    init() {
        // console.log('Initializing Appointment Module');

        // Initialize calendar if present
        if (AppointmentCalendar.isAvailable()) {
            this.calendar = new AppointmentCalendar();
        }

        // Initialize form if present
        if (AppointmentForm.isAvailable()) {
            this.form = new AppointmentForm();
        }
    }

    /**
     * Get calendar instance for external access
     */
    getCalendar() {
        return this.calendar;
    }

    /**
     * Get form instance for external access
     */
    getForm() {
        return this.form;
    }

    /**
     * Check if module is available on current page
     */
    static isAvailable() {
        return AppointmentCalendar.isAvailable() || AppointmentForm.isAvailable();
    }

    /**
     * Factory method to create instance only if needed
     */
    static createIfNeeded() {
        if (AppointmentModule.isAvailable()) {
            return new AppointmentModule();
        }
        return null;
    }
}
